import { MainNavbar } from "@/components/layout/MainNavbar";
import { MainFooter } from "@/components/layout/MainFooter";
import { useLanguage } from "@/contexts/LanguageContext";
import { useDynamicSeoData } from "@/hooks/useDynamicSeoData";
import { getHomePageSchemas } from "@/utils/jsonLdSchemas";
import { SEOHead } from "@/components/seo/SEOHead";
import { HeroSection } from "@/components/home/HeroSection";
import { TrustSection } from "@/components/home/TrustSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { HowItWorksSection } from "@/components/home/HowItWorksSection";
import { ExpertiseSection } from "@/components/home/ExpertiseSection";
import { WhyUsSection } from "@/components/home/WhyUsSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { CTASection } from "@/components/home/CTASection";
import ReferencesSection from "@/components/home/ReferencesSection";

export default function HomePage() {
  const { language } = useLanguage();
  const { seoData: seo } = useDynamicSeoData('home', language);
  const schemas = getHomePageSchemas();

  return (
    <div className="min-h-screen">
      <SEOHead title={seo.title} description={seo.description}>
        {schemas.map((schema, index) => (
          <script key={index} type="application/ld+json">
            {JSON.stringify(schema)}
          </script>
        ))}
      </SEOHead>
      <MainNavbar />
      <main>
        <HeroSection />
        <TrustSection />
        <ServicesSection />
        <HowItWorksSection />
        <ExpertiseSection />
        <WhyUsSection />
        <ReferencesSection />
        <TestimonialsSection />
        <CTASection />
      </main>
      <MainFooter />
    </div>
  );
}
